import { render, staticRenderFns } from "./AddressBlacklist.vue?vue&type=template&id=72aec02e&"
import script from "./AddressBlacklist.vue?vue&type=script&lang=js&"
export * from "./AddressBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports